export default "__VITE_ASSET__C6j5UPBA__"